import { REFI_MFE_UUID } from '../utils/refi-mfe-uuid.js';

function isStaticCloud() {
  return window.location.host === 'auto-refi-dev.clouddqt.capitalone.com' || window.location.host === 'auto-refi-sb.clouddqt.capitalone.com' || window.location.host === 'auto-refi-perf.clouddqt.capitalone.com';
}

const ENV_PATH = isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_WEB_UI_CONST = {
  ENV_PATH,
  sessionStorageKey: 'auto-refi-session',
  localStorageKey: 'refi-host-app-local-storage',
  experimentsOverrideKey: 'refi-experiments-override',
  isNewAppKey: 'auto-refi-new-app',
  hasCoApp: 'auto-refi-has-co-app',
  appReferenceId: 'auto-refi-app-reference-id',
  openAppIds: 'auto-refi-open-apps-id',
  easeOfferAllocation: 'ease-offer-connected-entry',
  grEaseZingerOffer: 'auto-refi-gr-ease-offer-zinger',
  offerBanner: 'auto-refi-offer-banner',
  grEaseOfferFlow: 'auto-refi-gr-ease-offer-valid',
  grEaseControlFlow: 'auto-refi-gr-ease-control-flow',
  grEaseControlFlowViewed: 'auto-refi-gr-ease-control-flow-viewed',
  easeGrStsRoutingFlag: 'auto-refi-ease-gr-routing',
  easeBauStsRoutingFlag: 'auto-refi-ease-bau-routing',
  stsParam: 'assertion',
  attemptedStsBypass: 'attemptedStsBypass',
  successfulStsBypass: 'successfulStsBypass',

  storageProps: {
    currentState: 'currentState',
  },
  LANDING_PAGE_URL: 'https://autorefi.capitalone.com',
  LANDING_PAGE_URL_QA: 'https://autorefi-ext-preprod.capitalone.com',
  REFRESH_PAGE_URL: 'https://coaf-refi-web-ui.capitalone.com',
  REFRESH_PAGE_URL_QA: 'https://coaf-refi-web-ui-qa.capitalone.com',
  LOGIN_LOCAL_URL: 'http://localhost:4211/login',
  LOGIN_SB_URL: 'https://auto-refi-sb.clouddqt.capitalone.com/login',
  LOGIN_QA_URL: 'https://autorefi-ext-preprod.capitalone.com/login',
  LOGIN_QA_URL_NEW: 'https://coaf-refi-web-ui-qa.capitalone.com/login',
  LOGIN_PROD_URL: 'https://autorefi.capitalone.com/login',
  LOGIN_PROD_URL_NEW: 'https://coaf-refi-web-ui.capitalone.com/login',
  LOGOUT_DXGW_URL: `${ENV_PATH}/protected/831647/host-app/bff/auth/logout`,
  EASE_GR_LANDING_PAGE: 'https://www.capitalone.com/auto-financing/refinance/offer/?PFFSRCID=S-DA-1234567890E-DAD-0013',
  EASE_BAU_LANDING_PAGE: 'https://www.capitalone.com/auto-financing/refinance?code=abcd&PFFSRCID=S-DA-1234567890E-DAD-0013',
  EASE_GR_PREFIX: 'COAF_V1_EAS_GR',
  EASE_HELM_PREFIX: 'COAF_V1_EAS_HELM',
  EASE_BAU_PREFIX: 'COAF_V1_EAS_BAU',
  CW_GR_PREFIX: 'COAF_V1_CW_GR',
  CW_BAU_PREFIX: 'COAF_V1_CW_BAU',
  CW_HELM_PREFIX: 'COAF_V1_CW_HELM',
  cwOfferStsRoutingFlag: 'auto-refi-cw-offer-routing',
  cwBauStsRoutingFlag: 'auto-refi-cw-bau-routing',
  CW_OFFER_LANDING_PAGE: 'https://www.capitalone.com/auto-financing/refinance/offer/',
  CW_BAU_LANDING_PAGE: 'https://www.capitalone.com/auto-financing/refinance/',
  refiMarketingParam: 'refi-marketing',
  isUpfrontOffersKey: 'auto-refi-upfront-offers',
  isIconicV2Key: 'auto-refi-iconic-prequal-v2',
  marketingSourceStorageKey: 'auto-refi-marketing-source',
  MARKETING_ATTRIBUTE_COOKIE: 'afw3', // set in persist-marketing-attributes
  RETURN_CUST_COOKIE: 'auto-refi-return-cust', // set post-authentication by host-app-ui's processing-login
  OFFER_CODE_TIME_TO_LIVE_HOURS: 2, // hours
  PRODUCT_TYPE_SESSION_STORAGE_KEY: 'product_type',
  getEnv() {
    return window.location.hostname === 'autorefi.capitalone.com' || window.location.hostname === 'coaf-refi-web-ui.capitalone.com' ? 'prod' : 'qa';
  },
  isLocal() {
    return window.location.hostname.includes('local');
  },
  isProd() {
    return window.location.hostname === 'autorefi.capitalone.com' || window.location.hostname === 'coaf-refi-web-ui.capitalone.com';
  },
  isSBEnv() {
    return window.location.hostname === 'auto-refi-sb.clouddqt.capitalone.com';
  },
  isDevEnv() {
    return window.location.hostname === 'auto-refi-dev.clouddqt.capitalone.com';
  },
  isPerfEnv() {
    return window.location.hostname === 'auto-refi-perf.clouddqt.capitalone.com';
  },
  navigatedByReload() {
    return window.performance.getEntriesByType('navigation')[0].type === 'reload';
  },
  isCheckoutPage() {
    return window.location.href.includes('checkout');
  },
  timeOutUrl() {
    let timeOutURL;
    if (REFI_WEB_UI_CONST.isProd()) {
      timeOutURL = REFI_WEB_UI_CONST.LOGIN_PROD_URL;
    } else if (REFI_WEB_UI_CONST.isLocal()) {
      timeOutURL = REFI_WEB_UI_CONST.LOGIN_LOCAL_URL;
    } else if (REFI_WEB_UI_CONST.isSBEnv()) {
      timeOutURL = REFI_WEB_UI_CONST.LOGIN_SB_URL;
    } else {
      timeOutURL = REFI_WEB_UI_CONST.LOGIN_QA_URL;
    }
    return timeOutURL;
  },
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache, no-store, must-revalidate, max-age: 0',
    'Content-Type': 'application/json;v=1',
    'Api-Key': 'RTM',
    'Client-Correlation-Id': REFI_MFE_UUID.makeUUID(),
  },
  API: {
    fetchMfeOrder: `${ENV_PATH}/protected/831647/host-app/bff/fetch-mfe-order`,
    customerExperience: eAppId => `${ENV_PATH}/protected/831647/host-app/bff/applications/${eAppId}/customer-experience`,
    searchCustomerOffers: `${ENV_PATH}/private/2245043/refi-user-entry-bff/search-customer-offer`,
    persistMarketingAttributes: `${ENV_PATH}/protected/831647/host-app/bff/persist-marketing-attributes`,
    experimentAllocations: `${ENV_PATH}/protected/831647/host-app/bff/experiments`,
    experimentFeedback: `${ENV_PATH}/protected/831647/host-app/bff/experimentation/~/submit-feedback`,
  },
  WRAP_UP_MFE_LOCAL_STORAGE_KEYS: ['poi-continue-button-status', 'poi-exit-survey-submitted', 'poi-exit-survey-did-open'],
  C1_REFI_APPIDS: 'C1-REFI-APPIDS',
  C1_REFI_ID: 'C1_REFI_ID',
  EAPP_ID: 'eapp_id',

  LEADS_URL_PARAMS: {
    mainKey: 'state',
    subKey: 'rl',
    subKeyVal: 'y',
  },
  EXPERIMENTS: {
    TEST: 'TestExperiment',
    ICONIC: 'Iconic',
    MAIL_IN_TITLE: 'Mail-In-Title',
    DELAYED_HARDPULL: 'DelayedHardPull',
    NDI: 'NDI',
    ACCESS_CODE_CONNECTED_ENTRY: 'access-code-connected-entry',
    EASE_OFFER_CONNECTED_ENTRY: 'ease-offer-connected-entry',
    LIENHOLDER_THREE_WAY_CALL: 'lienholder-3way-experiment',
    PAYOFF_STATEMENT_UPLOAD: 'poUpload-experiment',
    VEHICLE_AND_LOAN_INTERVIEW: 'vehicle-and-loan-interview',
    IN_APP_DECLINE_DELAY: 'in-app-decline-delay',
    EASY_LOGIN: 'refi-easy-login',
    COMBINED_HARDPULL_CONTRACT: 'CombinedHardpull',
    ACCESS_CODE_EASE_LOGIN: 'access-code-ease-login',
  },
  NEW_RELIC_PLUGIN_NAME: 'refiPluginNewRelic',
  CLIENT_CORRELATION_ID_HEADER: 'Client-Correlation-Id',
  DOC_UPLOADED_FLAG: 'doc-uploaded-flag',
};

export const OFFER_CONST = {
  CONNECTED_ENTRY_FAILED_MESSAGE: 'Please come back at a later time to try your code again.',
  CONNECTED_ENTRY_CUSTOMER_OFFER_FAILED_HEADER: 'Our system ran into a problem',
  CONNECTED_ENTRY_CUSTOMER_OFFER_NULL_MESSAGE: 'Please try again. Make sure your access code matches what you were sent, and that your offer has not expired.',
  CONNECTED_ENTRY_NO_MATCH_HEADER: 'We couldn’t find a match',
  CONNECTED_ENTRY_DEFAULT_MESSAGE: 'Please enter your information below.',
  CONNECTED_ENTRY_NO_PREFILL_HEADER: 'Let’s match you to your offer',
  CONNECTED_ENTRY_MATCH_FOUND_HEADER: 'Offer matched! Next, sign in.',
  CONTINUE_WITHOUT_ACCESS_CODE: 'Continue without access code',
};

export const CODELESS_ENTRY_CONST = {
  // Feature Toggle Keys
  FEATURE_TOGGLE: 'codeless-entry',

  // Session Storage Keys
  SESSION_STORAGE: {
    V1_FLOW_KEY: 'auto-refi-codeless-entry-v1-flow',
    FLOW_VIEWED_KEY: 'auto-refi-codeless-entry-flow-viewed',
    ERROR_MESSAGE_COUNT_KEY: 'auto-refi-codeless-entry-show-error-message-count',
  },

  // Experiment Allocation Types
  ALLOCATION: {
    CONTROL: 'grlpcontrol',
    VARIANT_1: 'grlpv1',
  },

  // External URLs
  KOCHAVA_URLS: {
    PRODUCTION: 'https://capitalone.smart.link/q1kuprb65?siteid1=?',
    NON_PRODUCTION: 'https://capitalone-qa.smart.link/5lncuu2f4?siteid1=?',
  },

  // Copy
  TECHNICAL_DIFFICULTIES_HEADING: 'We’ve hit a snag',
  TECHNICAL_DIFFICULTIES_MESSAGE_RETRY: 'We’re having technical difficulties. Please try again.',
  TECHNICAL_DIFFICULTIES_MESSAGE_LATER: 'We’re having technical difficulties. Please try again later.',
  TRY_AGAIN_CTA: 'Try again',
  NO_OFFER_MATCH_HEADING: 'We couldn’t apply this offer code',
  NO_OFFER_MATCH_REASONS_INTRO: 'This usually happens if:',
  OFFER_EXPIRED_REASON: 'The offer code has expired.',
  OFFER_DIFFERENT_ACCOUNT_REASON: 'You are logged into a different profile than the one the offer was sent to.',
  NO_OFFER_MATCH_MESSAGE: 'You can still check your personalized rates in minutes with no impact to your credit score. Let’s see if you can save on your vehicle loan.',
  START_NEW_APPLICATION_CTA: 'Check my rates',
  SEE_OTHER_APPLICATIONS_CTA: 'See my other applications',
};

export const EXPRESS_RETURN_CONST = {
  EXPRESS_RETURN: 'express-return',
  EXPRESS_RETURN_CUSTOMER: 'auto-refi-express-return-customer',
};

export const RETURN_CUST_COOKIE_CONST = {
  // Feature Toggle Key
  FEATURE_TOGGLE: 'return-cust-cookie-login',
};

export const MARKETING_CONST = {
  COOKIE_DOMAIN: 'capitalone.com',
  COOKIE_PATH: '/',
  COOKIE_MAX_AGE: 2628000,
  COOKIE_SECURE: true,
  DELIM_CARET: '^',
  DELIM_PIPE: '|',
  EXTERNAL_ID_PLATFORM_IDENTIFIER: 'eid',
  COAF_PFFSOURCEID: 'PFFSRCID',
  PFFSRCID_PLATFORM_IDENTIFIER: 'pid',
  COAF_ANDROMEDA: 'a',
  COAF_EXTERNAL_ID_DEFAULT_VAL: 'COAF_BAU',
  COAF_PFFSOURCEID_DEFAULT_VAL: 'S-C1-12345678901-AHP-0001',
};

export const CURRENT_STEP = {
  LOGIN: 'login',
  LOGIN_: 'login/',
  OFFER: 'offer',
  EASE_OFFER: 'ease-offer',
  PICK_AN_APP: 'pick-an-app',
  CODELESS_ENTRY: 'codeless-entry',
  CODELESS_ENTRY_: 'codeless-entry/',
};

